// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import COOKIE from 'js-cookie'
import moment from 'moment'

const getCookie = cookieName => COOKIE.get(cookieName)

const clearAllCookies = function() {
  const cookies = COOKIE.all()
  return _.each(cookies, (_, name) => COOKIE.remove(name))
}

const setCookie = (name, value, options) => COOKIE.set(name, value, options)

const clearCookie = (name, options) => COOKIE.remove(name, options)

export { getCookie, setCookie, clearCookie, clearAllCookies }



// WEBPACK FOOTER //
// ./src/scripts/utils/CookieHelpers.js